import React, { useState } from "react";
import { Button, notification, Form, Input } from "antd";
import Screen from '../util/Extensions/Screens'
import RequestHandler from "../util/RequestHandler";
import LogoPic from '../assets/images/santiye_360_logo3.png'
const ForgotPassword = (props) => {
  const [disabled, setDisabled] = useState(false);

  const openNotificationWithIcon = type => {
    notification[type]({
      message: 'BAŞARILI',
      description:
        'Şifre yenileme linkiniz mail adresinize gönderilmiştir.',
      duration: 2,
    });
  };

  const onFinishFailed = () => setDisabled(false);

  const onFinish = values => {
    setDisabled(true);
    RequestHandler.post(`/Auth/ForgotPassword`, {
      email: values.email,
      screenOption: Screen.screen
    }).then((response) => {
      if (response.success) {
        openNotificationWithIcon('success');
        setTimeout(function () {
          props.history.push('/');
        }.bind(this), 2000);
      }
    });
  };

  return (
    <div className="gx-login-container" style={{ backgroundColor: '#f0f8ff' }}>
      <div className="gx-login-content">
        <div className="gx-login-header">
        <img src={LogoPic} alt='Santiye360' style={{ width: '70%' ,margin:'5% 0'}} />

        </div>
        <div className="gx-mb-4">
          <h3>Şifreni mi unuttun ?</h3>
          <p>Mail adresinizi yazdığnız takdirde şifrenizi yenilemeniz için bir link gönderilecektir.</p>
        </div>
        <Form
          initialValues={{ remember: true }}
          name="basic"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          className="gx-signin-form gx-form-row0">
          <Form.Item name="email" rules={[{ required: true, message: 'Lütfen mail adresinizi girin!' }]}>
            <Input className='gx-input-lineheight' type="email" placeholder="Email adresinizi girin" />
          </Form.Item>

          <Form.Item>
            <Button style={{ backgroundColor: '#6f5196', color: 'white',margin:'5% 0' }} htmlType="submit" disabled={disabled}>
              Gönder
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
}

export default ForgotPassword
